import React, { useEffect, useState } from 'react';
import { makeStyles,createMuiTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CircularProgress from '@material-ui/core/CircularProgress';
import ZTypography from '../typography/ZTypography'
import { green } from '@material-ui/core/colors';
import { ThemeProvider } from '@material-ui/styles';
import { Tooltip } from '@material-ui/core';

export default function ZButton(props) {
    const [loading, setLoading] = useState(false)
    const classes = useStyles();
    useEffect(() => {
        setLoading(props.isLoading)
    }, [props.isLoading, props.disabled])
    return (

        <div className={classes.root}>
            <ThemeProvider theme={theme}>
                {props.tooltip ? <Tooltip title={props.text ? props.text : "Coming Soon"} classes={{ tooltip: classes.customWidth }} arrow>
                    <Button
                    id={props?.id}
                        fullWidth={props.fullWidth}
                        size={props.size}
                        onClick={props.onClick}
                        className={props.className}
                        style={props.style}
                        variant={props.variant}
                        color={props.color}
                        disabled={props.disabled}
                        startIcon={props.icon ? <Icon>{props.icon}</Icon> : props.icon}
                        endIcon={props.endIcon ? <img src={props.endIcon} /> : props.endIcon}
                        to={props.to} 
                        component={props.component}
                    >
                        <img src={props.src} />
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        {props.name}
                    </Button>
                </Tooltip> :
                    <Button
                        id={props?.id}
                        fullWidth={props.fullWidth}
                        size={props.size}
                        onClick={props.onClick}
                        className={props.className}
                        style={props.style}
                        variant={props.variant}
                        color={props.color}
                        disabled={props.disabled}
                        startIcon={props.icon ? <Icon>{props.icon}</Icon> : props.icon}
                        endIcon={props.endIcon ? <img src={props.endIcon} /> : props.endIcon}
                        
                    >
                        <img src={props.src} />
                        {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                        {props.overflow ? props.name : <ZTypography noWrap className={props.buttonLabel}> {props.name}</ZTypography>}
                    </Button>
                }
            </ThemeProvider>
        </div>
    );
}
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(0.5),
        },
        '& button': {
            borderRadius: 4,            
            '& p': {
                fontSize: "1rem",
                fontFamily: "GT Walsheim Pro",
                fontWeight: 400,
                lineHeight: 1.5,

                '& + span': {
                    right: '1rem',
                    position: 'absolute'
                }
            },
        }
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },


    // contained:{
    //     background:Colors.productive,
    //     color: theme.palette.common.white,
    //     borderRadius:6,
    //     marginRight: 0
    // },

    // outlined:{
    //   background:theme.palette.common.white,
    //   color: Colors.productive,
    //   borderRadius:6,
    //   border: '0.5px solid',
    //   borderColor: Colors.productive,
    // },
    // primary:{color:theme.palette.primary.light},
    // secondary:{color:theme.palette.primary.main},
    customWidth: {
        fontSize: 14
    },
}));


const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#00AFEF",
            contrastText: "#fff",
        },
        secondary: {
            main: "#FF9567",
            contrastText: "#fff",
        },
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                // primary: {
                    color: "#fff",
                    background: "#00AFEF",
                    boxShadow:"none",
                    '&:hover': {
                        background: "#00AFEF",
                    },
                },
                containedSecondary: {
                    '&:hover': {
                        backgroundColor: "#FF9567",
                        '@media (hover: none)': {
                            backgroundColor: "#FF9567",
                        },
                    },
                },
            // },

            outlinedPrimary: {
                    border: '0.5px solid #00AFEF',
                    color: "#00AFEF",
                    '&:hover': {
                        backgroundColor: "#fff",
                        '@media (hover: none)': {
                            // border: '0.5px solid',
                            // borderColor: '#00AFEF',
                        },
                    },
                    focusVisible:{
                        backgroundColor: "#fff",
                    },
                },

                outlinedSecondary: {
                    border: '0.5px solid #FF9567',
                    color: "#FF9567",
                    backgroundColor: "#fff",
                    '&:hover': {
                        backgroundColor: "#fff",
                        '@media (hover: none)': {
                            // border: '0.5px solid',
                            // borderColor: '#00AFEF',
                        },
                    },
                    focusVisible:{
                        backgroundColor: "#fff",
                    },
                }
            }
        }
    // }
});

